import { Button } from "@src/stories/elements/Button/Button";
import React from "react";

interface MinicartActionsProps {
  show_cart?: boolean;
  settings?: {
    show_view_cart?: boolean;
    checkout_button_text?: string;
    checkout_button_text_style?: string;
    cart_button_text?: string;
    cart_button_text_style?: string;
    background_color?: string;
    checkout_button_background?: string;
    checkout_button_text_color?: string;
    cart_button_background?: string;
    cart_button_text_color?: string;
    cart_button_border_color?: string;
    button_border_radius?: string;
    button_height?: number;
    margin_bottom?: number;
    padding?: number;
    gap?: number;
    border?: string;
  };
}

export const MinicartActions = ({ show_cart = true, settings = {} }: MinicartActionsProps) => {
  // Extract settings with defaults
  const {
    checkout_button_text = "CHECKOUT",
    checkout_button_text_style = "font-medium",
    cart_button_text = "VIEW BAG",
    cart_button_text_style = "font-medium",
    background_color = "#FFF9F5",
    checkout_button_background = "#000000",
    checkout_button_text_color = "#ffffff",
    cart_button_background = "#ffffff",
    cart_button_text_color = "#000000",
    cart_button_border_color = "#000000",
    button_border_radius = "6px",
    button_height = 48,
    margin_bottom = 0,
    padding = 0,
    gap = 10,
    border = "none"
  } = settings;

  // Dynamically create style objects
  const containerStyle = {
    backgroundColor: background_color,
    marginBottom: `${margin_bottom}px`,
    paddingBottom: `16px`,
    paddingLeft: `16px`,
    paddingRight: `16px`,
    display: "flex",
    flexDirection: "column",
    gap: `${gap}px`,
    border
  };

  const checkoutButtonStyle = {
    backgroundColor: checkout_button_background,
    color: checkout_button_text_color,
    borderRadius: button_border_radius,
    height: `${button_height}px`,
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  };

  const cartButtonStyle = {
    backgroundColor: cart_button_background,
    color: cart_button_text_color,
    borderRadius: button_border_radius,
    height: `${button_height}px`,
    border: `1px solid ${cart_button_border_color}`,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  };

  return (
    <div className="minicart-actions mt-4pb-4 rounded-b-lg" style={containerStyle}>
      <Button type="button" style={checkout_button_text_style} className={`minicart-actions__checkout`} label={checkout_button_text} onClick={() => window.location.href = '/checkout'}/>

      {show_cart && (

        <Button type="button" style={cart_button_text_style} className={`minicart-actions__cart`} label={cart_button_text} onClick={() => window.location.href = '/cart'}/>
    
      )}
    </div>
  );
};